const ACTIONS = {
    NAV_CLICKED: 'NAVIGATION/NAV_CLICKED',
    NAV_SET_ACTIVE_TAB: 'NAVIGATION/NAV_SET_ACTIVE_TAB',
    UPDATE_WAYPOINT_VISIBILITY: 'NAVIGATION/UPDATE_WAYPOINT_VISIBILITY',
    DETERMINE_ACTIVE_NAV_TAB: 'NAVIGATION/DETERMINE_ACTIVE_NAV_TAB'
};

const ACTION_CREATORS = {
    navClicked(tabName) {
        return {
            type: ACTIONS.NAV_CLICKED,
            payload: {tabName}
        };
    },
    navSetActiveTab(navActiveTabIndex) {
        return {
            type: ACTIONS.NAV_SET_ACTIVE_TAB,
            payload: {navActiveTabIndex}
        };
    },
    updateWaypointVisibility(waypointId, value) {
        return {
            type: ACTIONS.UPDATE_WAYPOINT_VISIBILITY,
            payload: {waypointId, value}
        };
    },
    determineActiveNavTab() {
        return {
            type: ACTIONS.DETERMINE_ACTIVE_NAV_TAB,
            payload: {}
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
